// extracted by mini-css-extract-plugin
export var centerText = "_eg-8";
export var container = "_eg-0";
export var doughnutContainer = "_eg-7";
export var legend = "_eg-a";
export var legendItemColorDisplay = "_eg-b";
export var legendItemLabel = "_eg-d";
export var legendItemValue = "_eg-c";
export var lg = "_eg-5";
export var maxWidth = "_eg-9";
export var md = "_eg-4";
export var responsive = "_eg-6";
export var sm = "_eg-3";
export var xs = "_eg-2";
export var xxs = "_eg-1";